import apiRequest from "../../helpers/apiRequest";

export default async (user, date) => {
    return await apiRequest({
        method: 'get',
        url: `accounts/tutor/${user}/${date}`,
    })
}
